import * as React from "react";
import Scrollbars, { ScrollbarProps } from "react-custom-scrollbars";
import { useAppSelector } from "../../store/hooks";

interface Props extends ScrollbarProps {
  thumbStyle?: React.CSSProperties;
}

export const CustomScrollbars = React.forwardRef<any, Props>(({ thumbStyle, ...props }, ref) => {
  const theme = useAppSelector((state) => state.theme.theme);

  const scrollbarColor: string = theme == "light" ? "#CCCCCC" : "var(--color-gray-1200)";
  let _thumbStyle: React.CSSProperties = {
    backgroundColor: scrollbarColor,
    borderRadius: 6,
  };

  if (thumbStyle) {
    _thumbStyle = {
      ..._thumbStyle,
      ...thumbStyle,
    };
  }

  return (
    <Scrollbars
      ref={ref}
      /* Default */
      renderThumbHorizontal={({ style, ...props }) => (
        <div
          {...props}
          style={{
            ...style,
            ..._thumbStyle,
          }}
        />
      )}
      renderThumbVertical={({ style, ...props }) => (
        <div
          {...props}
          style={{
            ...style,
            ..._thumbStyle,
          }}
        />
      )}
      /* Specified Preferences */
      {...props}
    >
      {props.children}
    </Scrollbars>
  );
});
